import { coursesApi, membersApi } from "@services/apiMembersClient";
import { AxiosPromise } from "axios";

import {
  CreateCommentInput,
  CreateCommentOutput,
  DeleteCommentByIdInput,
  DeleteCommentInput,
  GetAnswerByCommentIdInput,
  GetAnswerByCommentIdOutput,
  GetCommentByIdInput,
  GetCommentByIdOutput,
  GetCommentConfigInput,
  GetCommentConfigOutput,
  GetCommentInput,
  GetCommentOutput,
  GetCommentsByContentIdInput,
  SetCommentApproveInput,
  SetCommentRefuseInput,
  SetCommentViewedInput,
  UpdateCommentByIdInput,
  UpdateCommentByIdOutput,
  UpdateCommentConfigInput,
  UpdateCommentConfigOutput,
} from "@_types/comments";
import { ResponsePaginationType } from "@_types/shared";

export const getCommentConfig = ({ uuid }: GetCommentConfigInput): AxiosPromise<GetCommentConfigOutput> => {
  return coursesApi.get(`/courses/${uuid}/comments-config`);
};

export const updateCommentConfig = (
  uuid: string,
  data: UpdateCommentConfigInput
): AxiosPromise<UpdateCommentConfigOutput> => {
  return coursesApi.patch(`/courses/${uuid}/comments-config`, data);
};

export const createComment = ({ ...data }: CreateCommentInput): AxiosPromise<CreateCommentOutput> => {
  return membersApi.post("/comments", { ...data });
};

export const getAnswersByCommentId = ({
  uuid,
}: GetAnswerByCommentIdInput): AxiosPromise<ResponsePaginationType<GetAnswerByCommentIdOutput>> => {
  return membersApi.get(`/comments/${uuid}/answers`);
};

export const getCommentsByContentId = ({
  contentUuid,
}: GetCommentsByContentIdInput): AxiosPromise<ResponsePaginationType<GetCommentOutput>> => {
  const params = { page: 1, pageSize: 100 };
  return membersApi.get(`/comments?content.uuid=${contentUuid}`, { params });
};

export const getComment = (params: GetCommentInput): AxiosPromise<ResponsePaginationType<GetCommentOutput>> => {
  return membersApi.get("/comments", { params });
};

export const getCommentById = ({ uuid }: GetCommentByIdInput): AxiosPromise<GetCommentByIdOutput> => {
  return membersApi.get(`/comments/${uuid}`);
};

export const updateCommentById = ({ uuid, ...data }: UpdateCommentByIdInput): AxiosPromise<UpdateCommentByIdOutput> => {
  return membersApi.patch(`/comments/${uuid}`, { ...data });
};

export const deleteCommentById = ({ uuid }: DeleteCommentByIdInput): AxiosPromise<void> => {
  return membersApi.delete(`/comments/${uuid}`);
};

export const deleteComment = ({ uuids }: DeleteCommentInput): AxiosPromise<void> => {
  return membersApi.delete(`/comments/to-delete`, { data: { uuids } });
};

export const setCommentApprove = (data: SetCommentApproveInput): AxiosPromise<void> => {
  return membersApi.post("/comments/to-approve", data);
};

export const setCommentDeclined = (data: SetCommentRefuseInput): AxiosPromise<void> => {
  return membersApi.post(`/comments/to-refuse`, data);
};

export const setCommentstoViewed = (data: SetCommentViewedInput): AxiosPromise<void> => {
  return membersApi.post(`/comments/to-viewed`, data);
};
